import "./FormikSelectDropdownComponent.scss";
import React, {useCallback} from "react";
import {FieldProps} from "formik";
import SelectDropdownComponent from "../select-dropdown/SelectDropdownComponent";
import _ from "lodash";

export interface FormikSelectDropdownComponentProps {
    label: string;
    placeholder?: string;
    sx?: any;
    variant?: "filled" | "standard" | "outlined" | undefined;
    size?: "small" | "medium" | undefined;
    color?: "error" | "primary" | "secondary" | "info" | "success" | "warning" | undefined;
    required?: boolean;
    options: Array<any>;
    isDataLoading?: boolean;
    isDataLoadingFailed?: boolean;
    isDataLoaded?: boolean;
    valueKey?: string;
    getOptionLabel?: (option: any) => string;
    onUpdate?: Function;
    multiple?: boolean;
    id?: any
    formikField: FieldProps;
    defaultValue?:any;
    disabled?:boolean;
    readOnly?:boolean;
}

const FormikSelectDropdownComponent = (props: FormikSelectDropdownComponentProps) => {

    const {
        label,
        id,
        options,
        formikField,
        defaultValue,
        onUpdate,
        isDataLoading,
        isDataLoaded,
        isDataLoadingFailed,
        readOnly,
        required,
        size,
        placeholder,
    } = props;

    let {variant, multiple, getOptionLabel, color, valueKey,disabled} = props;
    if (!variant) variant = "outlined";
    if (!multiple) multiple = false;
    if (!color) color = "secondary";
    if (!disabled) disabled = false;
    if (!getOptionLabel) getOptionLabel = (option => option.title);
    const {field, form} = formikField;
    const {name,value} = field;
    const {setFieldTouched, touched,validateField, errors, setFieldValue} = form;
    const hasError = _.get(touched, name) && !!(_.get(errors, name));

    const onValueChange = useCallback((value: any) => {
        let tempValue = value;
        (async () => {
            await setFieldValue(name, tempValue);
            await setFieldTouched(name);
            await validateField(name);
        })()
        if (onUpdate) {
            onUpdate(tempValue)
        }
    }, [name, onUpdate, setFieldTouched, setFieldValue,validateField]);

    const onBlur = useCallback(() => {
        setFieldTouched(name);
    }, [setFieldTouched,name]);

    return (
        <div>
            <SelectDropdownComponent
                name={name}
                value={value}
                label={label}
                id={id}
                size={size}
                disabled={disabled}
                sx={{
                    "& .MuiOutlinedInput-root": {
                        background: "#FAFAFA"
                    }
                }}
                variant={variant}
                color={color}
                options={options}
                defaultValue={defaultValue}
                isDataLoading={isDataLoading}
                isDataLoadingFailed={isDataLoadingFailed}
                isDataLoaded={isDataLoaded}
                valueKey={valueKey}
                onUpdate={onValueChange}
                readOnly={readOnly}
                multiple={multiple}
                required={required}
                placeholder={placeholder}
                getOptionLabel={getOptionLabel}
                hasError={hasError}
                onBlur={onBlur}
                errorMessage={hasError && _.get(errors, name)}
            />

        </div>
    )

};

export default FormikSelectDropdownComponent;
